import { DISCARD_REASON_LABELS, type TicketEventEntry, type TicketStateChange } from '@easyhelp/shared';

/**
 * Il perché di un cambio di stato della story #6, in coda al testo dell'evento: motivo dello scarto
 * (con l'originale per un duplicato), riapertura, chiusura automatica. Vuoto per gli altri cambi.
 */
export function stateChangeReason(change: TicketStateChange): string {
  if (change.discardReason) {
    const reason = DISCARD_REASON_LABELS[change.discardReason];
    return change.original ? ` Motivo: ${reason} di ${change.original}.` : ` Motivo: ${reason}.`;
  }
  if (change.reopening) return ' Riapertura: conta nelle statistiche.';
  if (change.automaticAfterDays !== undefined) {
    return ` Dopo ${change.automaticAfterDays} giorni da «Risolto» senza replica.`;
  }
  return '';
}

/** La versione di rilascio di una correzione registrata, in coda al testo dell'evento. */
export function correctionEventNote(entry: TicketEventEntry): string {
  return entry.correction?.release ? ` Rilascio ${entry.correction.release}.` : '';
}
